import { j as a } from "./jsx-runtime-B6kdoens.js";
import * as v from "react";
import { useRef as m, useState as T, useCallback as F, useId as A, useContext as K, useInsertionEffect as B, useMemo as I, useEffect as D, cloneElement as N, Children as S, isValidElement as V } from "react";
import { u as O, M as _, a as G, P as H, L as W } from "./motion-minimal-Crg_qVxv.js";
import { f as Y, i as q } from "./motion-jk0ivqSc.js";
function $() {
  const n = m(!1);
  return O(() => (n.current = !0, () => {
    n.current = !1;
  }), []), n;
}
function J() {
  const n = $(), [s, e] = T(0), r = F(() => {
    n.current && e(s + 1);
  }, [s]);
  return [F(() => Y.postRender(r), [r]), s];
}
class Q extends v.Component {
  getSnapshotBeforeUpdate(s) {
    const e = this.props.childRef.current;
    if (e && s.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = e.offsetHeight || 0, r.width = e.offsetWidth || 0, r.top = e.offsetTop, r.left = e.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function X({ children: n, isPresent: s }) {
  const e = A(), r = m(null), p = m({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: d } = K(_);
  return B(() => {
    const { width: f, height: c, top: x, left: l } = p.current;
    if (s || !r.current || !f || !c)
      return;
    r.current.dataset.motionPopId = e;
    const t = document.createElement("style");
    return d && (t.nonce = d), document.head.appendChild(t), t.sheet && t.sheet.insertRule(`
          [data-motion-pop-id="${e}"] {
            position: absolute !important;
            width: ${f}px !important;
            height: ${c}px !important;
            top: ${x}px !important;
            left: ${l}px !important;
          }
        `), () => {
      document.head.removeChild(t);
    };
  }, [s]), a.jsx(Q, { isPresent: s, childRef: r, sizeRef: p, children: v.cloneElement(n, { ref: r }) });
}
const P = ({ children: n, initial: s, isPresent: e, onExitComplete: r, custom: p, presenceAffectsLayout: d, mode: f }) => {
  const c = G(Z), x = A(), l = I(
    () => ({
      id: x,
      initial: s,
      isPresent: e,
      custom: p,
      onExitComplete: (t) => {
        c.set(t, !0);
        for (const i of c.values())
          if (!i)
            return;
        r && r();
      },
      register: (t) => (c.set(t, !1), () => c.delete(t))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    d ? [Math.random()] : [e]
  );
  return I(() => {
    c.forEach((t, i) => c.set(i, !1));
  }, [e]), v.useEffect(() => {
    !e && !c.size && r && r();
  }, [e]), f === "popLayout" && (n = a.jsx(X, { isPresent: e, children: n })), a.jsx(H.Provider, { value: l, children: n });
};
function Z() {
  return /* @__PURE__ */ new Map();
}
function ee(n) {
  return D(() => () => n(), []);
}
const h = (n) => n.key || "";
function te(n, s) {
  n.forEach((e) => {
    const r = h(e);
    s.set(r, e);
  });
}
function ne(n) {
  const s = [];
  return S.forEach(n, (e) => {
    V(e) && s.push(e);
  }), s;
}
const ce = ({ children: n, custom: s, initial: e = !0, onExitComplete: r, exitBeforeEnter: p, presenceAffectsLayout: d = !0, mode: f = "sync" }) => {
  q(!p, "Replace exitBeforeEnter with mode='wait'");
  const c = K(W).forceRender || J()[0], x = $(), l = ne(n);
  let t = l;
  const i = m(/* @__PURE__ */ new Map()).current, E = m(t), C = m(/* @__PURE__ */ new Map()).current, w = m(!0);
  if (O(() => {
    w.current = !1, te(l, C), E.current = t;
  }), ee(() => {
    w.current = !0, C.clear(), i.clear();
  }), w.current)
    return a.jsx(a.Fragment, { children: t.map((o) => a.jsx(P, { isPresent: !0, initial: e ? void 0 : !1, presenceAffectsLayout: d, mode: f, children: o }, h(o))) });
  t = [...t];
  const y = E.current.map(h), M = l.map(h), b = y.length;
  for (let o = 0; o < b; o++) {
    const u = y[o];
    M.indexOf(u) === -1 && !i.has(u) && i.set(u, void 0);
  }
  return f === "wait" && i.size && (t = []), i.forEach((o, u) => {
    if (M.indexOf(u) !== -1)
      return;
    const j = C.get(u);
    if (!j)
      return;
    const U = y.indexOf(u);
    let g = o;
    if (!g) {
      const k = () => {
        i.delete(u);
        const z = Array.from(C.keys()).filter((R) => !M.includes(R));
        if (z.forEach((R) => C.delete(R)), E.current = l.filter((R) => {
          const L = h(R);
          return (
            // filter out the node exiting
            L === u || // filter out the leftover children
            z.includes(L)
          );
        }), !i.size) {
          if (x.current === !1)
            return;
          c(), r && r();
        }
      };
      g = a.jsx(P, { isPresent: !1, onExitComplete: k, custom: s, presenceAffectsLayout: d, mode: f, children: j }, h(j)), i.set(u, g);
    }
    t.splice(U, 0, g);
  }), t = t.map((o) => {
    const u = o.key;
    return i.has(u) ? o : a.jsx(P, { isPresent: !0, presenceAffectsLayout: d, mode: f, children: o }, h(o));
  }), process.env.NODE_ENV !== "production" && f === "wait" && t.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), a.jsx(a.Fragment, { children: i.size ? t : t.map((o) => N(o)) });
};
export {
  ce as A
};
//# sourceMappingURL=index-LYq8AemS.js.map
